<template>
  <div>
    <!-- Step 1: DO Reference Input -->
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">DO Reference</label>
        <vs-input
          class="w-full"
          v-model="doReference"
          placeholder="Enter DO reference"
          @keyup.enter="searchPreview"
        />
      </div>
      <div class="vx-col md:w-1/4 w-full" style="display:flex;align-items:flex-end;">
        <vs-button
          color="warning"
          class="btn mb-4 md:mb-0"
          @click="searchPreview"
          :disabled="doReference == ''"
        >
          Search
        </vs-button>
      </div>
    </div>

    <!-- Step 2: Preview Section -->
    <div class="vx-row mt-6" v-if="showPreview" style="display:flex;align-items:stretch;">
      <!-- DO Info -->
      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">DO Info</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:40%;">DO Reference</td>
              <td style="padding:4px 0;">{{ previewData.do_reference }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Origin Warehouse</td>
              <td style="padding:4px 0;">{{ previewData.origin_warehouse }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Destination Warehouse</td>
              <td style="padding:4px 0;">{{ previewData.destination_warehouse }}</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Status</td>
              <td style="padding:4px 0;">{{ previewData.status }}</td>
            </tr>
          </table>
        </vs-card>
      </div>

      <!-- Records Akan Diupdate -->
      <div class="vx-col md:w-1/2 w-full" style="display:flex;">
        <vs-card style="width:100%;display:flex;flex-direction:column;">
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">Records Akan Diupdate</span>
          </div>
          <table style="width:100%">
            <tr>
              <td style="padding:4px 0;font-weight:bold;width:60%;">Delivery Order Details</td>
              <td style="padding:4px 0;">{{ previewData.records.delivery_order_details }} record(s)</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Inventories Transactions</td>
              <td style="padding:4px 0;">{{ previewData.records.inventories_transactions }} record(s)</td>
            </tr>
            <tr>
              <td style="padding:4px 0;font-weight:bold;">Inventories</td>
              <td style="padding:4px 0;">{{ previewData.records.inventories }} record(s)</td>
            </tr>
          </table>
        </vs-card>
      </div>
    </div>

    <!-- DO Details Table -->
    <div class="vx-row mt-4" v-if="showPreview">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <span style="font-size:14px;font-weight:600;">DO Details</span>
          </div>
          <div style="max-height: 300px; overflow-y: auto;">
            <table style="width:100%">
              <thead>
                <tr>
                  <th style="padding:4px 0;text-align:left;border-bottom:1px solid #ddd;">Pack ID</th>
                  <th style="padding:4px 0;text-align:left;border-bottom:1px solid #ddd;">Product</th>
                  <th style="padding:4px 0;text-align:left;border-bottom:1px solid #ddd;">Qty</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(detail, index) in previewData.details" :key="index">
                  <td style="padding:4px 0;border-bottom:1px solid #eee;">{{ detail.pack_id || '-' }}</td>
                  <td style="padding:4px 0;border-bottom:1px solid #eee;">{{ detail.product }}</td>
                  <td style="padding:4px 0;border-bottom:1px solid #eee;">{{ detail.qty }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </vs-card>
      </div>
    </div>

    <!-- Step 3: Mode Tabs -->
    <vs-tabs class="mt-5" v-model="activeModeTab" v-if="showModeTabs">
      <vs-tab label="TV (Pack ID)" />
      <vs-tab label="Bracket (Qty)" />
    </vs-tabs>

    <!-- TV (Pack ID) Input -->
    <div class="vx-row mt-4" v-if="activeModeTab === 0 && showModeTabs">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Pack ID</label>
        <vs-input
          class="w-full"
          v-model="packId"
          placeholder="Enter Pack ID"
        />
      </div>
    </div>

    <!-- Bracket (Qty) Input -->
    <div class="vx-row mt-4" v-if="activeModeTab === 1 && showModeTabs">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label pl-1">Qty</label>
        <vs-input
          class="w-full"
          v-model="qty"
          type="number"
          placeholder="Enter quantity"
        />
      </div>
    </div>

    <!-- Process Button -->
    <div class="vx-row mt-5" v-if="showModeTabs">
      <div class="vx-col md:w-1/4 w-full">
        <vs-button
          color="primary"
          @click="submitCancelGI"
          :disabled="!canSubmit || isSubmitting"
        >
          Process
        </vs-button>
      </div>
    </div>

    <!-- Confirm Modal -->
    <vs-popup title="Konfirmasi Cancel GI" :active.sync="showConfirmModal" v-if="previewData">
      <p style="margin-bottom:12px;">Apakah kamu yakin ingin membatalkan Good Issue untuk DO berikut?</p>
      <table style="width:100%;margin-bottom:16px;">
        <tr>
          <td style="padding:4px 0;font-weight:bold;width:40%;">DO Reference</td>
          <td style="padding:4px 0;">{{ doReference }}</td>
        </tr>
        <tr v-if="activeModeTab === 0">
          <td style="padding:4px 0;font-weight:bold;">Pack ID</td>
          <td style="padding:4px 0;">{{ packId }}</td>
        </tr>
        <tr v-if="activeModeTab === 1">
          <td style="padding:4px 0;font-weight:bold;">Qty</td>
          <td style="padding:4px 0;">{{ qty }}</td>
        </tr>
        <tr>
          <td style="padding:4px 0;font-weight:bold;">Origin → Destination</td>
          <td style="padding:4px 0;">{{ previewData.origin_warehouse }} → {{ previewData.destination_warehouse }}</td>
        </tr>
      </table>
      <div style="display:flex;justify-content:flex-end;">
        <vs-button color="grey" class="btn mr-2" @click="showConfirmModal = false">Batal</vs-button>
        <vs-button color="warning" class="btn" @click="confirmCancelGI">Ya, Cancel GI</vs-button>
      </div>
    </vs-popup>

    <!-- Result Section -->
    <div class="vx-row mt-10" v-if="result">
      <div class="vx-col md:w-full w-full">
        <div style="font-size:14px;font-weight:700;margin-bottom:12px;">Hasil Cancel GI</div>
        <div style="border:1px solid #ddd;border-radius:4px;overflow:hidden;">
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">DO REFERENCE</span>
            </div>
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">OLD WAREHOUSE</span>
            </div>
            <div class="vx-col md:w-1/3" style="padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">NEW WAREHOUSE</span>
            </div>
          </div>
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.do_reference }}</span>
            </div>
            <div class="vx-col md:w-1/3" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ result.old_warehouse_id }}</span>
            </div>
            <div class="vx-col md:w-1/3" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ result.new_warehouse_id }}</span>
            </div>
          </div>
          <div class="vx-row" style="border-top:1px solid #ddd;background:#f0f0f0;">
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Details Deleted: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.details_deleted }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Transactions Deleted: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.transactions_deleted }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Details Updated: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.details_updated }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Transactions Updated: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.transactions_updated }}</span>
            </div>
          </div>
          <div class="vx-row" style="border-top:1px solid #ddd;background:#f8f8f8;">
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Inventories Updated: </span>
              <span style="font-size:14px;">{{ result.inventories_updated }}</span>
            </div>
            <div class="vx-col md:w-1/4" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Inventories Created: </span>
              <span style="font-size:14px;">{{ result.inventories_created }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancelGoodIssue",
  data() {
    return {
      doReference: "",
      previewData: null,
      showPreview: false,
      showModeTabs: false,
      showConfirmModal: false,
      activeModeTab: 0,
      packId: "",
      qty: "",
      isSubmitting: false,
      result: null,
    };
  },
  computed: {
    canSubmit() {
      if (this.activeModeTab === 0) {
        return this.packId !== "";
      }
      return this.qty !== "" && this.qty > 0;
    },
  },
  methods: {
    // DUMMY: ganti ke this.$http.post("support/outbound/deliveryorder/cancel-gi/preview", { do_reference: this.doReference })
    searchPreview() {
      if (this.doReference == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "DO Reference is required",
        });
        return false;
      }

      this.$emit("loading", true);
      this.showPreview = false;
      this.showModeTabs = false;
      this.result = null;

      // DUMMY response — hapus setTimeout + mock, ganti dengan API call
      setTimeout(() => {
        this.previewData = {
          do_reference: this.doReference,
          origin_warehouse: "WH-ORIGIN (dummy)",
          destination_warehouse: "WH-DEST (dummy)",
          status: "Good Issued",
          details: [
            { pack_id: "PACK-001", product: "Product A (dummy)", qty: 10 },
            { pack_id: "PACK-002", product: "Product B (dummy)", qty: 5 },
          ],
          records: {
            delivery_order_details: 2,
            inventories_transactions: 2,
            inventories: 2,
          },
        };
        this.showPreview = true;
        this.showModeTabs = true;
        this.packId = "";
        this.qty = "";
        this.$emit("loading", false);
      }, 500);
    },

    submitCancelGI() {
      if (this.activeModeTab === 0 && this.packId == "") {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Pack ID is required",
        });
        return false;
      }

      if (this.activeModeTab === 1 && (this.qty == "" || this.qty <= 0)) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Qty must be greater than 0",
        });
        return false;
      }

      this.showConfirmModal = true;
    },

    // DUMMY: ganti ke this.$http.post("support/outbound/deliveryorder/cancel-gi", payload)
    confirmCancelGI() {
      this.showConfirmModal = false;
      this.isSubmitting = true;
      this.$emit("loading", true);

      // DUMMY response — hapus setTimeout + mock, ganti dengan API call
      setTimeout(() => {
        this.result = {
          do_reference: this.doReference,
          old_warehouse_id: 2,
          new_warehouse_id: 1,
          details_deleted: this.activeModeTab === 0 ? 1 : 0,
          transactions_deleted: this.activeModeTab === 0 ? 1 : 0,
          details_updated: this.activeModeTab === 1 ? 1 : 0,
          transactions_updated: this.activeModeTab === 1 ? 1 : 0,
          inventories_created: 1,
          inventories_updated: 1,
        };
        this.isSubmitting = false;
        this.$emit("loading", false);
        this.$vs.notify({
          color: "success",
          title: "Success",
          iconPack: "feather",
          icon: "icon-check",
          text: "Cancel GI berhasil diproses. (dummy response)",
        });
      }, 500);
    },
  },
};
</script>
